import styled from 'styled-components';
import colorSyntax from '@toast-ui/editor-plugin-color-syntax';
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css';
import { Editor } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/theme/toastui-editor-dark.css';
import 'tui-color-picker/dist/tui-color-picker.css';
import { useMutation } from '@tanstack/react-query';
import { runtimeConfig } from '../../../../../../shared/config/runtimeConfig';
import { AxiosCommonError } from '../../../../../../shared/types';
import { AxiosError } from 'axios';
import { handleError } from '../../../../../ui/err/handleError';
import { operationApis } from '../../../../../../shared/apis/operation/apis';

const ToastEditor = (props: any) => {
  const { editorRef, setImages } = props;

  const storageUrl = runtimeConfig.s3BucketUrl;

  const { mutateAsync: uploadImage } = useMutation((formData: FormData) => operationApis.uploadImage(formData), {
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });

  const onUploadImage = async (blob: any, callback: any) => {
    const formData = new FormData();
    formData.append('file', blob);
    const { data } = await uploadImage(formData);
    const url = storageUrl + '/' + data.result[0];
    setImages((prev: File[]) => [...prev, url]);
    callback(url, '');
  };

  return (
    <Wrap>
      <Editor
        plugins={[colorSyntax]}
        height="600px" // 에디터 창 높이
        hideModeSwitch
        frontMatter={false}
        useCommandShortcut={false}
        ref={editorRef} // DOM 선택용 useRef
        placeholder="내용을 입력해주세요."
        initialValue={props.defaultValue}
        previewStyle="vertical" // 미리보기 스타일 지정
        initialEditType="wysiwyg" // 초기 입력모드 설정
        toolbarItems={[
          // 툴바 옵션 설정
          ['heading', 'bold', 'italic', 'strike'],
          ['hr', 'quote'],
          ['ul', 'ol', 'task', 'indent', 'outdent'],
          ['table', 'image', 'link'],
          ['code', 'codeblock'],
        ]}
        hooks={{
          addImageBlobHook: onUploadImage,
        }} // 이미지 가로채기
      ></Editor>
    </Wrap>
  );
};

export default ToastEditor;

const Wrap = styled.div`
  width: 100%;
  button {
    // toast-ui 내부 button에 영향을 줘서 글로벌 스타일 상쇄
    padding: 0rem;
    font-weight: 500;
    display: inline;
  }
`;
